<template>
  <div v-if="!googleMapsLoaded && show">
  </div>
  <div v-else-if='emptyGeo' class="inner_block" :class="{error, 'field-error': has_error, 'nowrap': nowrap}">
    <VueGoogleAutocomplete
      :id="useId"
      classname='form-control select-city'
      :class="{'filled': change_val.length}"
      :types="'(cities)'"
      :placeholder="get_placeholder"
      v-on:placechanged='getAddressData'
      :country='country'
      :disabled="disabled"
      @change="change"
      @focus="focus"
      @blur="blur"
    />
    <label :for="useId" v-if="label && emptyGeo">{{ label }}</label>
    <div class="message" v-if="!!error">{{error}}</div>
  </div>
  <div v-else class='my-profile-form__city-container' :class="{'disabled': disabled, 'nowrap': nowrap}">
    <span>{{ selectedGeo.description }}</span>
    <div @click="remove_geo" class="delete-city"></div>
  </div>
</template>

<script>
  import VueGoogleAutocomplete from 'vue-google-autocomplete'

  export default {
    name: 'city-select',

    components: {
      VueGoogleAutocomplete
    },

    data() {
      return {
        change_val: '',
        is_focus: false,
        show: false
      }
    },

    computed: {
      emptyGeo () {
        return this.selectedGeo ? !this.selectedGeo.place_id : true
      },

      currentLocale () {
        if (this.lang) {
          return this.lang;
        }

        return this.$store.state.locale.value
      },

      googleMapsLoaded () {
        return this.$store.state.googleMapsLoaded || window.google
      },

      get_placeholder() {
        if (this.label) {
          return '';
        }

        if (this.placeholder) {
          return !this.is_focus ? this.placeholder : '';
        }

        return this.$tr('profile.profileForm.info.typeToSearch');
      }
    },

    methods: {
      // This methods checks loaded scripts on page,
      // try to find script GoogleMapsApi.
      // If found and it`s with different locale from current
      // - reload page.
      // If not - load script with current locale
      checkLoadedGoogleMaps () {
        const inlcudedScripts = document.getElementsByTagName('script')
        const alreadyHaveGoogleMaps = Array.from(inlcudedScripts)
          .some(i => i.src.includes('maps.googleapis.com'))

        // If found
        if (alreadyHaveGoogleMaps) {
          const gmaps = Array.from(inlcudedScripts).find(i => i.src.includes('maps.googleapis.com'))
          const a = document.createElement('a')
          a.href = gmaps.src

          // Extract language parameter and check it
          const language = a.search.indexOf('language') ? a.search.substring(a.search.indexOf('language')) : null
          const lang = language ? language.split('=').pop() : null

          if (lang !== this.currentLocale && this.is_reload) {
            setTimeout(() => {
              window.location.reload()
            }, 100)
          }
        } else {
          // Load needed script
          const s = document.createElement('script')
          s.setAttribute('src', 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCl7xtsUctZy9kCI2EDxQXbfSBbHuIRIsM&libraries=places' + `&language=${this.currentLocale}`)
          s.onload = () => {
            this.$store.commit('googleApiLoaded')
          }
          document.head.appendChild(s)
        }
      },

      remove_geo() {
        this.change('');
        this.deleteGeo();
      },

      change(val) {
        this.change_val = val;
      },

      focus() {
        this.is_focus = true;
      },

      blur() {
        this.is_focus = false;
      }
    },

    props: {
      selectedGeo: {
        type: Object,
        required: true
      },
      country: {
        type: String,
        default: ''
      },
      getAddressData: {
        type: Function,
        required: true
      },
      deleteGeo: {
        type: Function,
        required: true
      },
      useId: {
        type: String,
        default: 'id'
      },
      disabled: {
        type: Boolean,
        default: false
      },
      has_error: {
        type: Boolean,
        default: false
      },
      nowrap: {
        type: Boolean,
        default: false
      },
      is_reload: {
        type: Boolean,
        default: true
      },
      placeholder: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: ''
      },
      error: {
        type: String,
        default: ''
      },
      lang: {
        type: String,
        default: ''
      }
    },

    beforeMount () {
      this.checkLoadedGoogleMaps();
      this.show = true
    },
    destroyed() {
      this.show = false;
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/styles/colors.scss';
  @import '@/styles/variables.scss';

  .pac-container {
    z-index: 9999;
  }

  .pac-container:after {
    display: none;
    content: '';
  }

  .pac-icon-marker {
    display: none;
  }

  .pac-item,
  .pac-item-query {
    font-size: 14px;
  }

  .pac-item {
    padding-left: 12px;
  }

  .pac-item-query {
    margin-right: 5px;
    line-height: 30px;
  }

  .my-profile-form__city-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    border: 1px solid #ccc;
    cursor: default;
    border-radius: 4px;
    background-color: #fff;
    padding: 5px 12px;
    font-size: 16px;
    height: 40px;

    span {
      display: inline-block;
      padding-right: 15px;
    }

    &.disabled {
      opacity: 0.4;
    }
  }

  .nowrap {
    &.my-profile-form__city-container {
      span {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }

  .select-city {
    border-color: $input-border-color;

    &:focus {
      border-color: $green;
      box-shadow: none;
    }
  }

  .delete-city {
    position: relative;
    cursor: pointer;
    width: 15px;
    height: 15px;

    &:after, &:before {
      content: '';
      position: absolute;
      top: 6px;
      left: 0;
      display: block;
      width: 15px;
      height: 2px;
      border-radius: 2px;
      background-color: #545454;
      transition: opacity .2s;
    }

    &:after {
      transform: rotate(45deg);
    }

    &:before {
      transform: rotate(-45deg);
    }

    &:hover {
      &:after, &:before {
        opacity: .4;
      }
    }
  }
  .inner_block {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 640px;
  }
  .message {
    color: #F65046;
    // font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    line-height: 19px;
    font-size: 13px;
    letter-spacing: 0.005em;
    margin-top: 5px;
    margin-left: 10px;
  }
  .error .select-city,
  .field-error .select-city {
    border-color: #F65046;
  }

  label {
    color: #9FAAB6;
    font-size: 15px;
    transition: 0.2s ease all;
    cursor: pointer;
    position: absolute;
    bottom: 30px;
    left: 10px;
    transform: translateY(20px);
  }

  .select-city {
    &:focus ~ label {
      transform-origin: left;
      font-size: 13px;
      transform: translateY(0px);
    }
  }

  .filled {
    & ~ label {
      transform-origin: left;
      font-size: 13px;
      transform: translateY(0px);
    }
  }

  .error,
  .field-error {
    .select-city {
      & ~ label {
        bottom: 54px;
      }
    }
  }
  .page_registration {
    .select-city {
      border-bottom: 1px solid #d2d6e0;
      border-top: none;
      border-left: none;
      border-right: none;
      border-radius: 0;
    }
  }
</style>
